"use client";
import { updateCart, updateClientCart } from "@/app/store/slices/cart/cartSlice";
import { getCartThunk } from "@/app/store/slices/cart/cartThunk";
import { updateClientTryCart, updateTryCart } from "@/app/store/slices/try-cart/tryCartSlice";
import { getTryCartThunk } from "@/app/store/slices/try-cart/tryCartThunk";
import { Badge, BadgeProps, styled } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useAppDispatch, useAppSelector } from "@v2/lib/redux/hooks";
import { useAuthSession } from "@v2/hooks/useAuthSession";
import { ShoppingBag } from "lucide-react";
import Link from "next/link";
import { useEffect, useMemo } from "react";

interface IProps {
    white?: boolean;
}

export default function CartButton({ white }: IProps) {
    const { isReady, isAuthenticated } = useAuthSession();

    const { clientCart, serverCart } = useAppSelector(
        (store) => store.cart
    )

    const { clientTryCart, serverTryCart } = useAppSelector(
        (store) => store.tryCart
    )

    // No badge until the session is known: showing the guest count first
    // made the badge jump to the server count a moment later.
    const cartItemsCount = useMemo(() => {
        if (!isReady) return 0;
        if (isAuthenticated) return serverCart?.items?.length ?? 0;
        return clientCart?.items?.length ?? 0;
    }, [isReady, isAuthenticated, serverCart, clientCart?.items])

    const tryCartItemsCount = useMemo(() => {
        if (!isReady) return 0;
        if (isAuthenticated) return serverTryCart?.items?.length ?? 0;
        return clientTryCart?.items?.length ?? 0;
    }, [isReady, isAuthenticated, serverTryCart, clientTryCart?.items])

    const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
        '& .MuiBadge-badge': {
            left: 0,
            top: 4,
            border: `2px solid #fff`,
            padding: '0 4px',
            fontSize: 11
        },
    }));


    // if (true) {
    //     let itemCountsToShow = cartItemsCount
    //     if (itemCountsToShow === 0 && tryCartItemsCount > 0) {
    //         itemCountsToShow = tryCartItemsCount
    //     }
    // }

    return (
        <IconButton centerRipple sx={{ height: 42, width: 42 }} component={Link} href={cartItemsCount ?  `/fa/v2/cart` : tryCartItemsCount ? `/fa/v2/cart/try` : `/fa/v2/cart`} aria-label="نمایش سبد خرید">
            <StyledBadge badgeContent={tryCartItemsCount} color="success" anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}>
                <StyledBadge badgeContent={cartItemsCount} color="primary" >
                    <ShoppingBag
                        color={white ? "#fff" : "#000"}
                    />
                </StyledBadge>
            </StyledBadge>
        </IconButton>
    );
}


